
import { AttestMeddelandeView } from '../../../../../../../Leverantor/ObjektVyer/LeverantorFaktura/Components/AttestMeddelande/AttestMeddelande';
import ObjektVySida from '../../../../../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import AttributGrupp from '../../../../../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import { EDFullscreenPaper } from '../../../../../../../../../BaseComponents/FullscreenModal/Components/EDFullscreenPaper';
import { FakturansAttestanter } from '../../../../../../../Leverantor/ObjektVyer/LeverantorFaktura/Components/Attestanter';
import { Verifikationdetails_node_TEDEKBokfver__Associations_Ursprungsverifikation__Associations_Handelser__Associations_Levfaktura__Associations_Attestmeddelande_All } from '../../Queries/VerifikationQuery/_QueryTypes/Verifikationdetails';

interface IProps {
  id?: string;
  fakturaNr?: string;
  leverantor?: string;
  forfalloDatum?: string;
  messages: Verifikationdetails_node_TEDEKBokfver__Associations_Ursprungsverifikation__Associations_Handelser__Associations_Levfaktura__Associations_Attestmeddelande_All[];
}

const EkonomiskAnalysVerifikationAttestanterOchMeddelanden: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <EDFullscreenPaper fullHeight>
      <ObjektVySida
        caption="Attestanter"
        collectionName=""
        forceActive
        sidNr={1}
      >
        <ObjektVyKolumner>
          <ObjektVyKolumn fullPage>
            <AttributGrupp caption="Attestanter">
              <FakturansAttestanter id={props.id ?? null} allExpanded />
            </AttributGrupp>
          </ObjektVyKolumn>
          <ObjektVyKolumn fullPage>
            <AttributGrupp caption="Meddelanden">
              <AttestMeddelandeView
                messages={props.messages}
                id={props.id ?? null}
              />
            </AttributGrupp>
          </ObjektVyKolumn>
        </ObjektVyKolumner>
      </ObjektVySida>
    </EDFullscreenPaper>
  );
};

export default EkonomiskAnalysVerifikationAttestanterOchMeddelanden;
